import { useCallback } from 'react';
import { Button, IconAlert, IconTrash } from '@direct-frontend/components';
import { logEventString } from '@adv-frontend/yastore-modules/logger';
import { dashboardAlertSeverityToColorMap } from '#entities/dashboardAlert';
import { type OpenApiSchemaAlert } from '#shared/api/schema';
import { format } from '#shared/lib/string';
import { InfoBlock } from '#shared/ui/InfoBlock';
import styles from './DashboardAlert.module.css';

type DashboardAlertProps = {
    alert: OpenApiSchemaAlert;
    onAction: VoidFunction;
    onRead: VoidFunction;
};

export const DashboardAlert = ({ alert, onAction, onRead }: DashboardAlertProps) => {
    const hasButton = alert.button_url && alert.button_text;

    const isNotCritical = alert.severity !== 'red';

    const handleMoreButtonClick = useCallback(() => {
        logEventString('DashboardAlert.MoreButtonClick', 'true', { alertId: alert.id });
        onAction();
    }, [alert.id, onAction]);

    const handleReadButtonClick = useCallback(() => {
        onRead();
        onAction();
        logEventString('DashboardAlert.DeleteButtonClick', 'true', { alertId: alert.id });
    }, [alert.id, onAction, onRead]);

    return (
        <div className={styles.infoBlockContainer}>
            <InfoBlock
                icon={IconAlert}
                type="icon"
                className={styles.infoBlock}
                color={dashboardAlertSeverityToColorMap[alert.severity]}
                bottomText={format(alert.created_at, 'pretty-date')}
                buttons={
                    hasButton && (
                        <Button
                            color="contrast"
                            onClickNative={handleMoreButtonClick}
                            size="s"
                            href={alert.button_url}
                            isDownload={alert.button_download}
                        >
                            {alert.button_text}
                        </Button>
                    )
                }
            >
                {alert.msg}
                {isNotCritical && (
                    <Button
                        aria-label="Скрыть уведомление"
                        title="Скрыть уведомление"
                        className={styles.readAction}
                        onClick={handleReadButtonClick}
                        color="contrast"
                        size="s"
                        icon={IconTrash}
                    />
                )}
            </InfoBlock>
        </div>
    );
};
